import AlasCore from 'alas';
import MsPackage from 'alas/packages/ms';
import Status from './status';
import * as User from './user';
import * as Farm from './farm';
import * as Crop from './crop';
export const alas = new AlasCore();
export const status = Status;
alas.setLocale('zh-tw');
alas.addPackage(MsPackage);
alas.addContainer('user', User.Container);
alas.addContainer('farm', Farm.Container);
alas.addContainer('crop', Crop.Container);
export default alas;
